import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createIncomeService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.income, payload)).data;
};

export const getIncomeService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.income}`, signal)).data;
}

export const updateIncomeService = async (payload) => {
  let filteredPayload = {
    "incomeId" : payload.incomeId,
    "userId": payload.userId,
    "amount": payload.amount,
    "description": payload.description,
    "incomeDate": payload.incomeDate,
  }
  return (await axiosInstance.put(`${APIROUTE.income}/${payload.incomeId}`, filteredPayload)).data;
};
